//header hover dropdown
$('.site-nav--has-dropdown').hover(
  function() {
    $( this ).addClass( "site-nav--active-dropdown" );
  }, function() {
    $( this ).removeClass( "site-nav--active-dropdown" );
  }
);
//custom add to cart
function customAddToCart(){
  $('.quick_ajax_atc').click(function(e){
  e.preventDefault();
  var protitle = $(this).parents('form').find('.qty_container').attr('data-title');
  var proprice = $(this).parents('form').find('.qty_container').attr('data-price');
  var proimg= $(this).parents('form').find('.qty_container').attr('data-img');
  var qty = $(this).parents('form').find('.quantity').val();
  var productid = $(this).parents('form').find('.product_id').val();
  jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
          quantity: qty,
          id: productid
      },
      dataType: 'json',           
      success: function() {
        $(".quick_view-modal-content .close").trigger('click');
        $("#CartCount").load(location.href + " #CartCount>*");
        $(".custom-cart-popup").load(location.href + " .custom-cart-popup>*");
        $('.custom-cart-popup-wrapper .cart_item_title').html(protitle);
        $('.custom-cart-popup-wrapper .cart_item_qty').html('Quantity: '+qty);
        $('.custom-cart-popup-wrapper .cart_item_price').html('Price: <span class="product_unitprice">'+proprice+'</span>');
        $('.custom-cart-popup-wrapper .cart_item_image').attr('src', proimg);
        $('.custom-cart-popup-wrapper').removeClass('custom-cart-popup-wrapper--hidden');
        setTimeout(function(){ 
          $('.custom-cart-popup-wrapper').addClass('custom-cart-popup-wrapper--hidden');
        }, 2000);
      },
      error: function() {
        $(".quick_view-modal-content .close").trigger('click');
        alert('Oops! Something went wrong. Please try to add your product again. If this message persists, the item may not be available.');
      }
  });
    

});
}
$('.custom-cart-popup__close').click(function(){
  $('.custom-cart-popup-wrapper').addClass('custom-cart-popup-wrapper--hidden');
});

customAddToCart();
//quick view
$(".quick-view-button").click(function(e){
	e.preventDefault();
  var qvcontent = $(this).next().html();
  $('#qv-inner').html(qvcontent);
  $('.qvloader').show();
//  $('body').addClass('qv-open');
  $("#quick_view-Modal").show();
  $('#qv-inner').css('opacity','0');

  $('#qv-inner .product-single__media-wrapper').hover(
    function() {
      var zoomUrl = $(this).data('zoom');
      $(this).zoom({
        url: zoomUrl
      });
    }, function() {
      $(this).trigger('zoom.destroy');
    }
  );  
  $('.ProductDescAccordion button').click(function(){
    var clickedid = $(this).attr('aria-controls');
    var checkaria = $(this).attr('aria-expanded');
    if(checkaria == 'false'){
      $('dt button').attr('aria-expanded','false');
      $('dd').attr('aria-hidden','true');
      $('dd').hide();
      $(this).attr('aria-expanded','true');
      $('#qv-inner .'+clickedid).attr('aria-hidden','false');
      $('#qv-inner .'+clickedid).show();
    }
    else{
      $(this).attr('aria-expanded','false');
      $('#qv-inner .'+clickedid).attr('aria-hidden','true');
      $('#qv-inner .'+clickedid).hide();
    }
  });
  var checkaccopen = $('.ProductDescAccordion button[aria-controls="panel-01"]').attr('aria-expanded');
  if(checkaccopen == 'false'){
    $('.ProductDescAccordion button[aria-controls="panel-01"]').trigger('click');
  }
  setTimeout(function(){ 
    $('.qvloader').hide();
    $('#qv-inner').css('opacity','1');
    customAddToCart();
  }, 100);
});
$(".quick_view-modal-content .close").click(function(){
  $("#quick_view-Modal").hide();
 // $('body').removeClass('qv-open');
  $('#qv-inner').html('');
});
var modal = $("#quick_view-Modal");
$(window).click(function(e) {
  if (e.target == modal ) {
    $("#quick_view-Modal").hide();
  //   $('body').removeClass('qv-open');
    $('#qv-inner').html('');
  }
});

$(window).scroll(function(){
  //sticky header
  if ($(window).scrollTop() >= 115) {
    $('#AccessibleNav').addClass('fixed-header');
  } else {
    $('#AccessibleNav').removeClass('fixed-header');
  }
  // mobile sticky header
  if ($(window).scrollTop() >= 230) {
    $('.mobile_navigation').addClass('fixed-header');
  } else {
    $('.mobile_navigation').removeClass('fixed-header');
  }

  //back to top
  if ($(this).scrollTop() > 100) { 
    $('#scroll').fadeIn(); 
  } else { 
    $('#scroll').fadeOut(); 
  } 
}); 
$('#scroll').click(function(){ 
  $("html, body").animate({ scrollTop: 0 }, 600); 
  return false; 
});
  
// mobile menu closure
$('.mobile_menu_close').click(function(){
  $('.js-mobile-nav-toggle').trigger('click');
});
$('.mobile-nav--open').click(function(){ 
  $("html, body").animate({ scrollTop: 0 }, 600); 
  return false; 
});

// sidebar toggle
function acccheck(){
  if($(window).width() <= 768) {
    $('.sidebar .inner_main_list').addClass('mobile_inner_main_list');
    $('.sidebar').addClass('mobile_sidebar');
    $('.mobile_inner_main_list').hide();
  }else{
    $('.mobile_inner_main_list').show();
    $('.sidebar .inner_main_list').removeClass('mobile_inner_main_list');
    $('.sidebar').removeClass('mobile_sidebar');
  }
}
acccheck();
$(window).on('resize orientationchange', function() {
  acccheck();
});

$(".mobile_sidebar .menu_title").click(function(){
 // console.log('trigger');
  if($(this).hasClass('.sidebar_sub_active')){
  //  console.log('already active');
    $(this).removeClass('.sidebar_sub_active');
    $(this).parent().find('.mobile_inner_main_list').slideUp('slow');
  }else{
   // console.log('not active');
    $(this).addClass('.sidebar_sub_active');
    $(this).parent().find('.mobile_inner_main_list').slideDown('slow');
  }
});
//collection list-grid viewand number of products displayed 
Shopify.queryParams = {};
if (location.search.length) {
  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
};
jQuery('#p_show')
.bind('change', function () {
  Shopify.queryParams.view = jQuery(this).val();
  location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
});
jQuery('#grid_list_show')
.bind('change', function () {
  Shopify.queryParams.view = jQuery(this).val();
  location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
});

//price filter collection
if ($("body").hasClass("template-collection")) { 
$ = jQuery;
 $(function () {
   setTimeout(function(){ 
   var collmin = $('#collection_min_price').text();
   var collmax = $('#collection_max_price').text();
   var amnt = '$'+collmin+' - '+'$'+collmax;
   var completecoll = $('#Collection').html();
      $('#slider-container').slider({
          range: true,
          min: parseInt(collmin),
          max: parseInt(collmax),
          values: [collmin, collmax],
          create: function() {
              $("#amount").val(amnt);
          },
          slide: function (event, ui) {
              $("#amount").val("$" + ui.values[0] + " - $" + ui.values[1]);
            $(".filter_min").text(ui.values[0]);
            $(".filter_max").text(ui.values[1]);
              var mi = ui.values[0];
              var mx = ui.values[1];
              filterSystem(mi, mx);
          }
        
      })
       }, 1000);
});
}
  function filterSystem(minPrice, maxPrice) {
      $("#Collection .product_with_quickView").hide().filter(function () {
          var price = parseInt($(this).data("price"), 10);
          return price >= minPrice && price <= maxPrice;
      }).show();
  }

// Collection sidebar accordion
$('.sidebar-acc .accordion-title').click(function(){
  var checkactive = $(this).parent().hasClass('active');
  if(checkactive){
    $(this).parent().removeClass('active');
    $(this).parent().find('.accordion-inner').slideUp();
  }else{
    $(this).parent().addClass('active');
    $(this).parent().find('.accordion-inner').slideDown();
  }
});
if ($("body").hasClass("template-product")) {
  
  //product tabs
  $('.tabs .tablinks').click(function(){
    var dataid = $(this).attr('data-id');
    $('.tabs .tablinks').removeClass('active');
    $(this).addClass('active');
    $('.tabcontent').removeClass('active');
    $('#'+dataid).addClass('active');
  });
  
}
if ($("#recently-viewed-products").length > 0) {
  setTimeout(function(){ 
    if($('.single_product').length > 0){
      $('#recently-viewed-products').parent('.outer_main').removeClass('re-hidden');
      var height = $('#recently-viewed-products').height()+50;
      $('#recently-viewed-products').parent('.outer_main').height(height);
    }else{
      $('#recently-viewed-products').parent('.outer_main').addClass('re-hidden');
      $('#recently-viewed-products').parent('.outer_main').hide();
    }
    var actheight = $('#recently-viewed-products').height();
    
    setTimeout(function(){ 
      if($('.single_product').length == 0){
         $('#recently-viewed-products').parent('.outer_main').hide();
      }
      var height = $('#recently-viewed-products').height();
    //  console.log(actheight+'actheight');
     //  console.log(height+'height');
    if(height != actheight){
  //    console.log(actheight+'actheight');
  //     console.log(height);
      var newheight = $('#recently-viewed-products').height()+50;
   //   console.log(newheight);
      $('#recently-viewed-products').parent('.outer_main').height(newheight);
    }
  }, 1000);
    
    
  }, 1000);
  
  
  
}

// $( document ).ready(function() {
//   $.ajax({
//     type: "post",
//     url: 'https://nationalcrm.com/biocidesystems/',
//     data: {
//       view: $('#productSKU').val()
//     },
//     dataType:'html',
//     beforeSend: function () {

//     },
//     success: function (data) {
//       $('.review-trustpilot-widget').html(data);
//     }
//   });
// });

$( document ).ready(function() {
  var modal = document.getElementById("subscription-Modal");
  var span = document.getElementsByClassName("subscription-close")[0];
  var subscriptionpopup = localStorage.getItem("subscription-popup");
  if (subscriptionpopup == true) {
    modal.style.display = "none";
  }else{
    modal.style.display = "block";
  }

  span.onclick = function() {
    modal.style.display = "none";
    localStorage.setItem("subscription-popup", "true");
  }

  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
      localStorage.setItem("subscription-popup", "true");
    }
  }
  
  
});